import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy } from '@angular/core';
import mapboxgl from 'mapbox-gl';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-location-tracker',
  templateUrl: './location-tracker.component.html',
  styleUrls: ['./location-tracker.component.scss']
})
export class LocationTrackerComponent implements OnDestroy {


  // map!: google.maps.Map;
  // vehicleMarker!: google.maps.Marker;
  // traveledPath!: google.maps.Polyline;
  // remainingPath!: google.maps.Polyline;
  // directionsService = new google.maps.DirectionsService();
  // directionsRenderer = new google.maps.DirectionsRenderer();

  // route: { lat: number; lng: number }[] = [];
  // currentLocation!: { lat: number; lng: number };
  // routeIndex = 0;

  // ngOnInit(): void {
  //   this.route = this.generateRandomRoute(12.971598, 77.594566, 2); // Start and end points for roadmap
  //   this.currentLocation = this.route[0]; // Initial location
  //   this.initializeMap();
  //   this.drawRoadMap();
  //   this.simulateVehicleMovement();

  // }

  // initializeMap(): void {
  //   this.map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
  //     center: this.currentLocation,
  //     zoom: 14,
  //   });

  //   this.directionsRenderer.setMap(this.map);

  //   this.vehicleMarker = new google.maps.Marker({
  //     position: this.currentLocation,
  //     map: this.map,
  //     icon: {
  //       url: 'assets/vechile img.svg',
  //       scaledSize: new google.maps.Size(50, 50),
  //     },
  //   });
  // }

  // drawRoadMap(): void {
  //   if (this.route.length < 2) {
  //     console.error('Route must have at least two points to draw a roadmap.');
  //     return;
  //   }

  //   const request: google.maps.DirectionsRequest = {
  //     origin: new google.maps.LatLng(this.route[0].lat, this.route[0].lng),
  //     destination: new google.maps.LatLng(this.route[this.route.length - 1].lat, this.route[this.route.length - 1].lng),
  //     travelMode: google.maps.TravelMode.DRIVING,
  //     waypoints: this.route
  //       .slice(1, this.route.length - 1)
  //       .map(point => ({ location: new google.maps.LatLng(point.lat, point.lng), stopover: true })),
  //   };

  //   this.directionsService.route(request, (result, status) => {
  //     if (status === google.maps.DirectionsStatus.OK) {
  //       this.directionsRenderer.setDirections(result);
  //     } else {
  //       console.error('Error fetching directions:', status);
  //     }
  //   });
  // }

  // simulateVehicleMovement(): void {
  //   const interval = setInterval(() => {
  //     if (this.routeIndex < this.route.length - 1) {
  //       const currentLatLng = new google.maps.LatLng(this.route[this.routeIndex].lat, this.route[this.routeIndex].lng);

  //       this.routeIndex++;
  //       this.currentLocation = this.route[this.routeIndex];

  //       this.vehicleMarker.setPosition(currentLatLng);
  //       this.map.panTo(currentLatLng);
  //     } else {
  //       clearInterval(interval);
  //       alert('Vehicle has reached the destination!');
  //     }
  //   }, 2000);
  // }

  // generateRandomRoute(centerLat: number, centerLng: number, numPoints: number): { lat: number; lng: number }[] {
  //   const randomRoute = [];
  //   const radius = 0.2; // ~10km range

  //   for (let i = 0; i < numPoints; i++) {
  //     const randomLat = centerLat + (Math.random() - 0.5) * radius;
  //     const randomLng = centerLng + (Math.random() - 0.5) * radius;
  //     randomRoute.push({ lat: randomLat, lng: randomLng });
  //   }

  //   return randomRoute;
  // }











  // map!: google.maps.Map;
  // vehicleMarker!: google.maps.Marker;
  // // Simulated route (pickup to drop)
  // route: { lat: number; lng: number }[] = [
  //   { lat: 12.971598, lng: 77.594566 }, // Pickup (e.g., Bengaluru)
  //   { lat: 14.4167, lng:78.2333 }, // Pickup (e.g., Bengaluru)
  //   { lat: 12.975833, lng: 77.605456 },
  //   { lat: 12.978845, lng: 77.617734 },
  //   { lat: 12.982445, lng: 77.628617 },
  //   { lat: 12.984500, lng: 77.641219 }, // Drop (e.g., a destination)
  //   { lat: 9.9950, lng: 76.2868 }, // Drop (e.g., a destination)
  // ];
  

  // currentLocation = this.route[0]; // Start at the pickup location
  // routeIndex = 0; // Track current position on the route

  // ngOnInit(): void {
  //   this.initializeMap();
  //   this.simulateVehicleMovement();
  // }

  // /**
  //  * Initialize Google Map with pickup location
  //  */
  // initializeMap(): void {
  //   this.map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
  //     center: this.currentLocation,
  //     zoom: 14
  //   });

  //   // Add vehicle marker
  //   this.vehicleMarker = new google.maps.Marker({
  //     position: this.currentLocation,
  //     map: this.map,
  //     icon: {
  //       url: 'https://maps.google.com/mapfiles/kml/shapes/cabs.png', // Vehicle icon
  //       scaledSize: new google.maps.Size(50, 50)
  //     }
  //   });
  // }

  // /**
  //  * Simulate vehicle movement along the route
  //  */
  // simulateVehicleMovement(): void {
  //   const interval = setInterval(() => {
  //     if (this.routeIndex < this.route.length - 1) {
  //       // Move to the next point on the route
  //       this.routeIndex++;
  //       this.currentLocation = this.route[this.routeIndex];

  //       // Update marker position and center map
  //       this.vehicleMarker.setPosition(this.currentLocation);
  //       this.map.setCenter(this.currentLocation);
  //     } else {
  //       // Stop when the vehicle reaches the drop location
  //       clearInterval(interval);
  //       alert('Vehicle has reached the drop location!');
  //     }
  //   }, 2000); // Update every 2 seconds
  // }









  private _map: mapboxgl.Map | null = null;
  private vehicleMarker: mapboxgl.Marker | null = null;
  private traveledCoords: [number, number][] = [];
  private remainingCoords: [number, number][] = [];

  // Route (randomly generated)
  route: { lat: number; lng: number }[] = [];
  currentLocation!: { lat: number; lng: number };
  routeIndex = 0; // Track the current position on the route

  ngOnInit(): void {
    this.route = this.generateRandomRoute(14.4167, 78.2333, 20);
    this.currentLocation = this.route[0];
    this.initializeMap();
  }

  ngOnDestroy(): void {
    if (this._map) { this._map.remove(); this._map = null; }
  }

  /**
   * Initialize Mapbox map with the starting location
   */
  initializeMap(): void {
    const element = document.getElementById('map');
    if (!element) return;
    this._map = new mapboxgl.Map({
      container: element,
      style: 'mapbox://styles/mapbox/streets-v12',
      center: [this.currentLocation.lng, this.currentLocation.lat],
      zoom: 14,
    });

    const el = document.createElement('div');
    el.style.backgroundImage = 'url(assets/vechile img.svg)';
    el.style.width = '50px'; el.style.height = '50px';
    el.style.backgroundSize = 'cover';

    this._map.on('load', () => {
      (this._map as mapboxgl.Map).resize();
      this.vehicleMarker = new mapboxgl.Marker({ element: el })
        .setLngLat([this.currentLocation.lng, this.currentLocation.lat])
        .addTo(this._map as mapboxgl.Map);

      this.remainingCoords = this.route.map(p => [p.lng, p.lat] as [number, number]);

      (this._map as mapboxgl.Map).addSource('remaining', {
        type: 'geojson',
        data: { type: 'Feature', geometry: { type: 'LineString', coordinates: this.remainingCoords }, properties: {} }
      });
      (this._map as mapboxgl.Map).addLayer({
        id: 'remaining', type: 'line', source: 'remaining',
        paint: { 'line-color': '#FF0000', 'line-width': 4 }
      });

      (this._map as mapboxgl.Map).addSource('traveled', {
        type: 'geojson',
        data: { type: 'Feature', geometry: { type: 'LineString', coordinates: [] }, properties: {} }
      });
      (this._map as mapboxgl.Map).addLayer({
        id: 'traveled', type: 'line', source: 'traveled',
        paint: { 'line-color': '#00FF00', 'line-width': 4 }
      });

      this.simulateVehicleMovement();
    });
  }

  /**
   * Simulate vehicle movement and update the route colors
   */
  simulateVehicleMovement(): void {
    const interval = setInterval(() => {
      if (this.routeIndex < this.route.length - 1) {
        const curr = this.route[this.routeIndex];
        const lngLat: [number, number] = [curr.lng, curr.lat];

        this.traveledCoords.push(lngLat);
        (this._map!.getSource('traveled') as mapboxgl.GeoJSONSource).setData({
          type: 'Feature', geometry: { type: 'LineString', coordinates: this.traveledCoords }, properties: {}
        });

        const remaining = this.route.slice(this.routeIndex + 1).map(p => [p.lng, p.lat] as [number, number]);
        (this._map!.getSource('remaining') as mapboxgl.GeoJSONSource).setData({
          type: 'Feature', geometry: { type: 'LineString', coordinates: remaining }, properties: {}
        });

        this.routeIndex++;
        this.currentLocation = this.route[this.routeIndex];
        this.vehicleMarker?.setLngLat(lngLat);
        this._map?.panTo([curr.lng, curr.lat]);
      } else {
        clearInterval(interval);
        alert('Vehicle has reached the destination!');
      }
    }, 2000);
  }

  /**
   * Generate a random route around a given central location
   * @param centerLat Latitude of the central location
   * @param centerLng Longitude of the central location
   * @param numPoints Number of random points to generate
   * @returns Array of random latitude and longitude points
   */
  generateRandomRoute(centerLat: number, centerLng: number, numPoints: number): { lat: number; lng: number }[] {
    const randomRoute = [];
    const radius = 0.2; // ~10km range

    for (let i = 0; i < numPoints; i++) {   
       const randomLat = centerLat + (Math.random() - 0.5) * radius;
      const randomLng = centerLng + (Math.random() - 0.5) * radius;
      randomRoute.push({ lat: randomLat, lng: randomLng });
    }

    return randomRoute;
  }

























  // map!: google.maps.Map;
  // vehicleMarker!: google.maps.Marker;
  // traveledPath!: google.maps.Polyline;
  // remainingPath!: google.maps.Polyline;

  // // Simulated route (pickup to drop)
  // route: { lat: number; lng: number }[] = [
  //   { lat: 12.971598, lng: 77.594566 }, // Bengaluru (Pickup)
  //   { lat: 12.975833, lng: 77.605456 },
  //   { lat: 12.978845, lng: 77.617734 },
  //   { lat: 12.982445, lng: 77.628617 },
  //   { lat: 10.039081, lng: 76.378586 }, // Destination
  //   { lat: 28.7041, lng: 77.1025 }, // Destination

  // ];

  // currentLocation = this.route[0]; // Start at the pickup location
  // routeIndex = 0; // Track the current position on the route

  // ngOnInit(): void {
  //   this.initializeMap();
  //   this.drawRoutePaths();
  //   this.simulateVehicleMovement();
  // }

  // /**
  //  * Initialize Google Map with the starting location
  //  */
  // initializeMap(): void {
  //   this.map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
  //     center: this.currentLocation,
  //     zoom: 14,
  //   });

  //   // Add vehicle marker
  //   this.vehicleMarker = new google.maps.Marker({
  //     position: this.currentLocation,
  //     map: this.map,
  //     icon: {
  //       url: 'https://maps.google.com/mapfiles/kml/shapes/cabs.png', // Vehicle icon
  //       scaledSize: new google.maps.Size(50, 50),
  //     },
  //   });
  // }

  // /**
  //  * Draw the route paths (traveled and remaining)
  //  */
  // drawRoutePaths(): void {
  //   // Initialize the remaining path (red)
  //   this.remainingPath = new google.maps.Polyline({
  //     path: this.route,
  //     geodesic: true,
  //     strokeColor: '#FF0000', // Red for remaining path
  //     strokeOpacity: 1.0,
  //     strokeWeight: 4,
  //   });
  //   this.remainingPath.setMap(this.map);

  //   // Initialize the traveled path (green)
  //   this.traveledPath = new google.maps.Polyline({
  //     path: [],
  //     geodesic: true,
  //     strokeColor: '#00FF00', // Green for traveled path
  //     strokeOpacity: 1.0,
  //     strokeWeight: 4,
  //   });
  //   this.traveledPath.setMap(this.map);
  // }

  // /**
  //  * Simulate vehicle movement and update the route colors
  //  */
  // simulateVehicleMovement(): void {
  //   const interval = setInterval(() => {
  //     if (this.routeIndex < this.route.length - 1) {
  //       // Convert to google.maps.LatLng before pushing
  //       const currentLatLng = new google.maps.LatLng(this.route[this.routeIndex].lat, this.route[this.routeIndex].lng);
  //       this.traveledPath.getPath().push(currentLatLng);
  
  //       // Update the remaining path
  //       const remainingCoordinates = this.route
  //         .slice(this.routeIndex + 1)
  //         .map(point => new google.maps.LatLng(point.lat, point.lng));
  //       this.remainingPath.setPath(remainingCoordinates);
  
  //       // Move to the next point
  //       this.routeIndex++;
  //       this.currentLocation = this.route[this.routeIndex];
  
  //       // Update marker position and center the map
  //       this.vehicleMarker.setPosition(currentLatLng);
  //       this.map.panTo(currentLatLng);
  //     } else {
  //       // Stop when the vehicle reaches the destination
  //       clearInterval(interval);
  //       alert('Vehicle has reached the destination!');
  //     }
  //   }, 2000); // Update every 2 seconds
  // }
  




  // map!: google.maps.Map;
  // vehicleMarker!: google.maps.Marker;
  // routePath!: google.maps.Polyline;

  // // Simulated route (pickup to drop)
  // route: { lat: number; lng: number }[] = [
  //   { lat: 12.971598, lng: 77.594566 }, // Pickup (e.g., Bengaluru)
  //   { lat: 14.4167, lng: 78.2333 }, // Intermediate point
  //   { lat: 12.975833, lng: 77.605456 },
  //   { lat: 12.978845, lng: 77.617734 },
  //   { lat: 12.982445, lng: 77.628617 },
  //   { lat: 12.984500, lng: 77.641219 }, // Intermediate point
  //   { lat: 9.9950, lng: 76.2868 }, // Drop (e.g., Kochi)
  // ];

  // currentLocation = this.route[0]; // Start at the pickup location
  // routeIndex = 0; // Track current position on the route

  // ngOnInit(): void {
  //   this.initializeMap();
  //   this.drawRoutePath();
  //   this.simulateVehicleMovement();
  // }

  // /**
  //  * Initialize Google Map with pickup location
  //  */
  // initializeMap(): void {
  //   this.map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
  //     center: this.currentLocation,
  //     zoom: 6, // Adjust zoom level for the route
  //     mapTypeId: 'roadmap' // Use the roadmap view
  //   });

  //   // Add vehicle marker
  //   this.vehicleMarker = new google.maps.Marker({
  //     position: this.currentLocation,
  //     map: this.map,
  //     icon: {
  //       url: 'https://maps.google.com/mapfiles/kml/shapes/cabs.png', // Vehicle icon
  //       scaledSize: new google.maps.Size(50, 50)
  //     }
  //   });
  // }

  // /**
  //  * Draw the route path on the map
  //  */
  // drawRoutePath(): void {
  //   this.routePath = new google.maps.Polyline({
  //     path: this.route,
  //     geodesic: true,
  //     strokeColor: '#FF0000', // Red color for the route
  //     strokeOpacity: 1.0,
  //     strokeWeight: 2
  //   });
  //   this.routePath.setMap(this.map); // Add the route path to the map
  // }

  // /**
  //  * Simulate vehicle movement along the route
  //  */
  // simulateVehicleMovement(): void {
  //   const interval = setInterval(() => {
  //     if (this.routeIndex < this.route.length - 1) {
  //       // Move to the next point on the route
  //       this.routeIndex++;
  //       this.currentLocation = this.route[this.routeIndex];

  //       // Update marker position and center map
  //       this.vehicleMarker.setPosition(this.currentLocation);
  //       this.map.setCenter(this.currentLocation);
  //     } else {
  //       // Stop when the vehicle reaches the drop location
  //       clearInterval(interval);
  //       alert('Vehicle has reached the drop location!');
  //     }
  //   }, 2000); // Update every 2 seconds
  // }


}